import React from 'react';
import { AsyncStorage } from 'react-native';

export default class StateStorage {
  setState(route, state) {
    AsyncStorage.getItem('STATE', (error, result) => {
      let states;
      if (result) {
        try {
          states = JSON.parse(result);
        }
        catch (error) {
          console.log('Failed to parse STATE, resetting it', error);
          states = {};
        }
      }
      else {
        states = {};
      }
      states[route] = state;

      AsyncStorage.setItem('STATE', JSON.stringify(states));
    });
  }

  getState(route, callback) {
    AsyncStorage.getItem('STATE', (error, result) => {
      if (!error && result) {
        try {
          const states = JSON.parse(result);
          callback(states[route]);
        }
        catch (error) {
          console.log('Failed to parse STATE, skipping it', error);
          callback();
        }
      }
      else {
        callback();
      }
    });
  }

  removeState(callback) {
    AsyncStorage.removeItem('STATE', () => callback && callback());
  };
}

export const stateStorage = new StateStorage();
